import http from '../utils/http-common'
const getAll = (param) => {
  return http.get('/door-types', { params: param })
}
const DoorTypeDataService = {
  getAll,
}
export default DoorTypeDataService
